import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { SUPPORTED_LANGUAGES, RTL_LANGUAGES } from './types';
import { setLocaleCookieClient } from './cookie-utils';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = useCallback((languageCode: string) => {
    // Update i18n
    i18n.changeLanguage(languageCode);
    // Sync cookie so server can access it
    setLocaleCookieClient(languageCode);
  }, [i18n]);

  const currentLanguage = SUPPORTED_LANGUAGES.find(
    lang => lang.code === i18n.language
  ) || SUPPORTED_LANGUAGES[0];

  const isRTL = RTL_LANGUAGES.includes(i18n.language);

  return {
    currentLanguage,
    changeLanguage,
    isRTL,
    supportedLanguages: SUPPORTED_LANGUAGES,
  };
};
